import { BehaviorSubject } from "rxjs";

export const PreviewSubject = new BehaviorSubject(0);
